<div>
    <app-vehicle-verification-identification (verifyClick)="verifyCallback($event)" (cancelClick)="cancelClickEvent()"
        *ngIf="showVinForm; else elseBlock" [currentVehicle]="currentVehicle"></app-vehicle-verification-identification>

    <ng-template #elseBlock>
        <app-vehicle-verification-details [currentVehicle]="currentVehicle" (continueClick)="continueClickEvent($event)"
            (retryClick)="retryCallback()"></app-vehicle-verification-details>
    </ng-template>
</div>